export default [
  'Diet Type',
  'Diet Formulation',
  'Carbon Footprint',
  // 'Net Zero Milling',
];
